export const CheckDuplicateNoOfString = array => {
  const count = {};

  array.forEach(item => {
    if (count[item]) {
      count[item] += 1;
      return;
    }
    count[item] = 1;
  });
  return count;
};
